import ApiInstance from './instance'
import { IResidentTransactionsLineItemsFilters, ITransactionEffectiveDate, ITransactionFilters, URL_MAPPING } from '@zunta/configurations'

const { transactions: transactionsUrls } = URL_MAPPING

export default class TransactionsApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  getResidentTransactions (residentId: number | string, filters: ITransactionFilters): Promise<{ total: number, transactions: ITransactionEffectiveDate[] }> {
    return this.instance.doGet(`${transactionsUrls.prefix}${transactionsUrls.getResidentTransactions.path}/${residentId}`, filters)
  }

  getTransactionLineItems (transactionId: number) {
    return this.instance.doGet(`${transactionsUrls.prefix}${transactionsUrls.getTransactionLineItems.path}/${transactionId}`, {}, 'getTransactionLineItems')
  }

  getResidentTransactionLineItems (residentId: number | string, filters: IResidentTransactionsLineItemsFilters) {
    return this.instance.doGet(`${transactionsUrls.prefix}${transactionsUrls.getResidentTransactionsLineItems.path}/${residentId}`, filters)
  }

  getGroupedPaymentsTotals (residentId: number | string) {
    return this.instance.doGet(`${transactionsUrls.prefix}/getGroupedTransactionsTotals/${residentId}`)
  }

  getAging (residentId: number | string) {
    return this.instance.doGet(`${transactionsUrls.prefix}/getAging/${residentId}`)
  }
  getAgingDetails (transactionId: number | string) {
    return this.instance.doGet(`${transactionsUrls.prefix}/getAging/details/${transactionId}`)
  }
}
